import { Link, useParams } from 'react-router-dom';
import { useContent } from '../context/ContentContext';
import { LoadingState } from '../components/LoadingState';
import { ErrorState } from '../components/ErrorState';
import { CategoryHero } from '../components/CategoryHero';
import { findHighLevelIssue, countHighLevelItems } from '../lib/contentUtils';

export function HighLevelIssuePage() {
  const { hlSlug } = useParams<{ hlSlug: string }>();
  const { data, loading, error, reload } = useContent();

  if (loading) return <LoadingState />;
  if (error || !data) return <ErrorState message={error ?? 'No data'} onRetry={reload} />;

  const issue = hlSlug ? findHighLevelIssue(data, hlSlug) : undefined;
  if (!issue) {
    return (
      <div className="page">
        <ErrorState message="Issue category not found." />
      </div>
    );
  }

  const totalEntries = countHighLevelItems(issue);

  return (
    <div className="page high-level-page">
      <nav className="breadcrumb" aria-label="Breadcrumb">
        <Link to="/explore">Explore</Link>
        <span aria-hidden> / </span>
        <span>{issue.title}</span>
      </nav>

      <CategoryHero
        issue={issue}
        meta={`${issue.specificIssues.length} subtopics · ${totalEntries} related entries`}
      />

      <ul className="specific-issue-list">
        {issue.specificIssues.map((spec) => (
          <li key={spec.id}>
            <Link to={`/issues/${issue.slug}/${spec.slug}`} className="specific-issue-card">
              <h3>{spec.title}</h3>
              <p>{spec.description}</p>
              <span className="specific-issue-meta">{spec.itemCount} entries →</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
